import React from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'
import CircularProgress from 'material-ui/CircularProgress'
import Hoverable from './common/HoverableItem'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'

import * as firebase from 'firebase'

const CUSTOMERS_ACTION_VIEW = 'V'
const CUSTOMERS_ACTION_EDIT = 'E'
//const CUSTOMERS_ACTION_DELETE = 'D'
const CUSTOMERS_OPEN_ACTION = 'O'
const CUSTOMERS_CLOSE_ACTION = 'C'

const CUSTOMERS_ACTIONS = [
  { key: CUSTOMERS_ACTION_VIEW, display: 'View' },
  { key: CUSTOMERS_ACTION_EDIT, display: 'Edit' }
  //{ key: CUSTOMERS_ACTION_DELETE, display: 'Delete' }
]

const CustomersListHeader = () => {
  return (
    <div style={styles.listItemContainer(true)}>
      <div style={styles.listColumn(true, null, true)}>Customer</div>
      <div style={styles.listColumn(true)}>Name</div>
      <div style={styles.listColumn(true)}>Email</div>
      <div style={styles.listColumn(true)}>Phone</div>
      <div style={styles.listColumn(true, null, false, 'center')}>Actions</div>
    </div>
  )
}

const getPrimaryContact = (customer) => {
  const id = _.keys(customer.contactsList)[0]
  if (id){
    return customer.contactsList[id]
  } else {
    return {}
  }
}

const CustomerTableRow = ({ index, customer, onPress, handleActionsClicked }) => {
  const primaryContact = getPrimaryContact(customer)
  return (
    <Hoverable id={customer.id} style={styles.row(index)} item={customer} onPress={onPress.bind(this, true)}>
      <div style={{ ...styles.listItemContainer(false) }}>
        <div style={styles.listColumn(false, null, true)}>{ customer.name }</div>
        <div style={styles.listColumn()}>{ primaryContact.contactName }</div>
        <div style={styles.listColumn()}>{ primaryContact.email }</div>
        <div style={styles.listColumn()}>{ primaryContact.phoneNumber }</div>
        <div style={styles.listColumn(false, null, false, 'center')}>
          <div style={styles.actionsContainer}>
            <div
              style={styles.viewLabel}
              onClick={() => onPress.bind(this, true)}>
              View
            </div>
            <div
              style={styles.actionsBox}
              onClick={(e) => handleActionsClicked(CUSTOMERS_OPEN_ACTION, e, customer, primaryContact)}>
              <i className='fa fa-caret-down'></i>
            </div>
          </div>
        </div>
      </div>
    </Hoverable>
  )

}

CustomerTableRow.propTypes = {
  index: PropTypes.number.isRequired,
  customer: PropTypes.object.isRequired,
  onPress: PropTypes.func,
  handleActionsClicked: PropTypes.func
}

export default class CustomersTable extends React.Component {

  static propTypes = {
    style: PropTypes.object,
    teamId: PropTypes.string.isRequired,
    onCustomerSelection: PropTypes.func,
    onEditCustomer: PropTypes.func
  }

  constructor(props) {
    super(props)
    this.state = {
      list: [],
      loading: true,
      showCustomerOptionsPopover: false,
      showCustomerDeletionConfirmationDialog: false
    }
  }

  componentDidMount() {
    this.attachCustomersListener(this.props)
  }

  componentWillUnmount() {
    this.detachCustomersListener(this.props)
  }

  attachCustomersListener = props => {
    firebase.database()
      .ref(`customers/${props.teamId}`)
      .orderByChild('name')
      .on('value', this.onUpdate)
  }

  detachCustomersListener = props => {
    firebase.database()
      .ref(`customers/${props.teamId}`)
      .orderByChild('name')
      .off('value', this.onUpdate)
  }

  onUpdate = (snapshots) => {
    const list = []
    if (snapshots){
      snapshots.forEach(snapshot => {
        const customer = snapshot.val()
        if (!customer.delete && customer.name){
          list.push(customer)
        } else if (!customer.delete){
          //TODO deal with customers with no name
        }
      })
    }

    this.setState({ list, loading: false })

  }

  handleActionsClicked = (action, event, customer, contact) => {

    if (event.stopPropagation){
      event.stopPropagation()
    }

    const newState = {}
    switch (action){
      case CUSTOMERS_OPEN_ACTION:
        newState['showCustomerOptionsPopover'] = true
        newState['anchorElement'] = event.currentTarget
        this.props.onCustomerSelection(false, customer, contact)
        break
      case CUSTOMERS_CLOSE_ACTION:
        newState['showCustomerOptionsPopover'] = false
        break
      case CUSTOMERS_ACTION_EDIT:
        newState['showCustomerOptionsPopover'] = false
        this.props.onEditCustomer()
        break
    }

    this.setState(newState)
  }

  render() {
    let customers = []
    if (this.state.loading) {
      customers = <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    }
    else
    if (!this.state.list.length) {
      customers = <div style={styles.zeroItems}>No customers have been added.</div>
    }
    else {
      customers = this.state.list.map((customer, index) =>
        <CustomerTableRow
          key={customer.id}
          index={index}
          customer={customer}
          onPress={this.props.onCustomerSelection}
          handleActionsClicked={this.handleActionsClicked}/>
      )
    }
    return (
      <div style={this.props.style}>
        <div>
          <CustomersListHeader />
          <div>
            { customers }
          </div>
          <Popover
            open={this.state.showCustomerOptionsPopover}
            anchorEl={this.state.anchorElement}
            anchorOrigin={{ horizontal: 'middle', vertical: 'bottom' }}
            targetOrigin={{ horizontal: 'left', vertical: 'bottom' }}
            onRequestClose={this.handleActionsClicked.bind(this, CUSTOMERS_CLOSE_ACTION)}>
            <Menu>
              {
                CUSTOMERS_ACTIONS.map(action => <MenuItem
                  key={action.key}
                  onTouchTap={event => this.handleActionsClicked(action.key, event)}
                  primaryText={action.display} />
                )
              }
            </Menu>
          </Popover>
        </div>
      </div>
    )
  }

}

const styles = {
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  row: index => ({
    backgroundColor: index % 2 ? '#eef7ff' : '#fff',
    borderBottom: 'none'
  }),
  listItemContainer: (isHeader) => ({
    display:'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: 45,
    justifyContent: 'space-between',
    borderBottom: isHeader ? '1px solid #527da3' : null,
    paddingTop: 4,
    paddingBottom: 4
  }),
  listColumn: (isHeader, width, isFirstColumn, textAlign) => ({
    color: isHeader ? '#356992' : '#757575',
    fontWeight: isHeader ? 500 : 400,
    letterSpacing: isHeader ? 0.6 : null,
    fontSize: 14,
    width: width || 180,
    marginLeft: isFirstColumn ? 16 : 0,
    textAlign: textAlign || 'left',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  }),
  listActionsColumn: {
    width: 144,
    justifyContent: 'center'
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  viewLabel: {
    cursor: 'pointer',
    color: '#179b93'
  },
  actionsBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    border: 'solid 1px #9b9b9b',
    borderRadius: 3,
    width: 20,
    height: 20,
    cursor: 'pointer'
  },
  statusBox: status => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 18,
    fontSize: 10,
    color: '#fff',
    borderRadius: 2,
    border: '1px solid ' + STATUS_BOX_COLOR[status] || '#9b9b9b',
    backgroundColor: STATUS_BOX_COLOR[status] || '#9b9b9b'
  }),
  zeroItems: {
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12
  }
}

const STATUS_BOX_COLOR = {
  sent: '#efad27',
  paid: '#7ed321',
  partial: '#a49fdb'
}



// WEBPACK FOOTER //
// ./src/customer/CustomersTable.js